import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mysolution.webp';
import screenshot_target from '../../../images/letterfunnel/jaappostma.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jaap Postma"
      firstname="Jaap"
      companyname="Mysolution"
      competition="Zvoove en Carerix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jaappostma.js